"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PollLearnerWrapper = void 0;

var _reactEmotion = require("react-emotion");

var _themeConfig = _interopRequireDefault(require("@lyearn-team/theme-config"));

var PollLearnerWrapper =
/*#__PURE__*/
(0, _reactEmotion.css)("padding:36px;width:360px;height:auto;background-color:", _themeConfig.default.color.dark.earth, ";.question-text{margin-bottom:32px;}.option-wrapper{margin-bottom:24px;}.image-option-wrapper{display:flex;flex-direction:row;align-items:center;padding-left:10px;width:100%;}.image-option{height:72px;width:72px;}.text-option{padding-left:12px;font-weight:500;font-size:16px;color:", _themeConfig.default.color.dark.silver, ";}");
exports.PollLearnerWrapper = PollLearnerWrapper;